import { useHistory, useParams } from "react-router-dom";
import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import { useEffect } from "react";

const BoardReportResult = () => {
  const history = useHistory();
  const { category_id } = useParams<{ category_id: string }>();
  useEffect(() => window.scrollTo(0, 0), []);
  const handleBackToListBoard = () => {
    history.push(`/message-board/categories/${category_id}`);
  };
  return (
    <div className={`${STBoardDetail.container} ${STBoardDetail.wrapper}`}>
      <div className={STBoardDetail.board}>
        <div
          className={`${STBoardDetail.boardReportResult} ${STBoardDetail.wrapper}`}
        >
          <div className={STBoardDetail.reportResultTitle}>
            ご協力ありがとうございました。
          </div>
          <div className={STBoardDetail.reportResultDescription}>
            報告者情報、報告内容については公開されることはございません。
            ご連絡いただいた内容は、ガイドラインに照らし合わせて確認を行います。
            違反が認められない場合には、対応・処理を実施しない場合もございますので
            ご了承いただけますと幸いです。
          </div>
          <button
            onClick={handleBackToListBoard}
            className={STBoardDetail.navigateButton}
          >
            掲示板一覧ページへ戻る＞
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoardReportResult;
